import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  Optional,
  Self,
  SkipSelf,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
@Component({
  selector: 'app-textarea',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor {
  @Input() maxlength: number = 0;
  @Input() minlength: number = 0;
  @Input() isRequired: boolean = false;
  @Input() type: string = 'text';
  @Input() label: string = '';

  @Input() submitted: boolean = false;
  @Input() rows: number = 1;
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  /** When provided, renders a read-only textarea with this value (no form control required) */
  @Input() standaloneValue?: string | null;
  @Output() action = new EventEmitter<void>();
  @Input() formControlName?: string; // مهم عشان نعرف اسم الكنترول
  constructor(@Optional() @SkipSelf() private controlContainer: ControlContainer) {}
  get control(): FormControl | null {
    return this.formControlName
      ? (this.controlContainer?.control?.get(this.formControlName) as FormControl)
      : null;
  }
  value: any = '';
  touched = false;
  // ControlValueAccessor methods
  onChange = (_: any) => {};
  onTouched = () => {};

  // get remainingChars(): number {
  //   if (!this.maxLength) return 0;
  //   return this.maxLength - (this.value ? this.value.length : 0);
  // }

  get remainingChars(): number | null {
    if (!this.control || !this.maxlength) return null;
    return this.maxlength - (this.control.value?.length || 0);
  }

  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    // this.disabled = isDisabled;
  }
  // Input change
  // handleInput(event: any) {
  //   const val = event.target.value;
  //   this.value = val;
  //   this.onChange(val);
  //   this.onTouched();
  // }
  handleInput(event: any) {
    let val = event.target.value;

    if (this.maxlength && val.length > this.maxlength) {
      val = val.substring(0, this.maxlength);
      event.target.value = val; // مهم جدًا
    }

    this.value = val;
    this.onChange(val);
    this.onTouched();
  }

  // Trigger external action
  triggerAction() {
    this.action.emit();
  }
  handleFocus() {
    // ممكن نضيف أي لوجيك عند الـ focus هنا
  }
  handleBlur() {
    this.control?.markAsTouched();
  }
  // get hasError(): boolean {
  //   return !!(
  //     this.control &&
  //     this.control.invalid &&
  //     (this.control.touched || this.control.dirty)
  //   );
  // }
  get errorMessages(): string | null {
    const control = this.control;
    if (!control || !control.errors) return null;
    const errors = control.errors;
    let message: string = '';
    const formattedName = this.formControlName
      ? this.customFormatControlName(this.formControlName)
      : '';
    if (errors['required']) {
      message = `${formattedName} is required.`;
    }
    if (errors['maxlength']) {
      message = `${formattedName} must not exceed ${errors['maxlength'].requiredLength} characters. (You entered ${errors['maxlength'].actualLength})`;
    }

    if (errors['minlength']) {
      message = `${formattedName} must be at least ${errors['minlength'].requiredLength} characters long.`;
    }

    return message;
  }
  private customFormatControlName(name: string): string {
    if (!name) return '';
    let formatted = name.replace(/([a-z])([A-Z])/g, '$1 $2');
    formatted = formatted.replace(/[_-]+/g, ' ');
    return formatted
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  // get hasError(): boolean {
  //   return !!(this.control && this.control.invalid && (this.control.touched || this.control.dirty));
  // }

  get hasError(): boolean {
    return !!(this.control && this.control.invalid && this.control.touched);
  }

  get isErrorString(): boolean {
    return typeof this.errorMessages === 'string';
  }

  get isErrorArray(): boolean {
    return Array.isArray(this.errorMessages);
  }

  trackByFn(index: number, item: string) {
    return item;
  }
}
